import React from 'react';
import { ITextButtonProps, TextButton } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

interface ICancelNewCardProps extends ITextButtonProps {}

export const CancelNewCard = (props: ICancelNewCardProps) => {
	const { t } = useTranslation();

	return (
		<TextButton type="button" variant="highlight" {...props}>
			{t('payment_form_cancel_button')}
		</TextButton>
	);
};
